export default __webpack_public_path__ + "static/media/qr_codeindex.3e6df896.svg";